/**
 * Data layer for `cap-types-approved-payout-revenue-clicks-conversion-pending`. Thin typed fetch wrappers over /api/v1/cap-types-approved-payout-revenue-clicks-conversion-pending.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface CapTypesApprovedPayoutRevenueClicksConversionPendingRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListCapTypesApprovedPayoutRevenueClicksConversionPendingResponse {
	count: number;
	items: CapTypesApprovedPayoutRevenueClicksConversionPendingRow[];
}

export interface CreateCapTypesApprovedPayoutRevenueClicksConversionPendingBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/cap-types-approved-payout-revenue-clicks-conversion-pending";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListCapTypesApprovedPayoutRevenueClicksConversionPendingResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListCapTypesApprovedPayoutRevenueClicksConversionPendingResponse>(res);
}

export async function create(body: CreateCapTypesApprovedPayoutRevenueClicksConversionPendingBody): Promise<CapTypesApprovedPayoutRevenueClicksConversionPendingRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<CapTypesApprovedPayoutRevenueClicksConversionPendingRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const capTypesApprovedPayoutRevenueClicksConversionPendingQueryKeys = {
	all: ["cap-types-approved-payout-revenue-clicks-conversion-pending"] as const,
	list: () => [...capTypesApprovedPayoutRevenueClicksConversionPendingQueryKeys.all] as const,
	detail: (id: string) => [...capTypesApprovedPayoutRevenueClicksConversionPendingQueryKeys.all, id] as const,
};
